module.exports = __webpack_public_path__ + "img/snow-mode-off.a2570b1f.svg";